import { INSTANCE } from './endpoint';

const getToken = () => `Bearer ${localStorage.getItem('token')}`;

export const getTestRunsApi = () =>
  INSTANCE.get('/v1/admin/test/runs', {
    headers: { Authorization: getToken() },
  }).then((res) => res.data);

export const getTestRunApi = (id: string) =>
  INSTANCE.get(`/v1/admin/test/runs/${id}`, {
    headers: { Authorization: getToken() },
  }).then((res) => res.data);

export const createTestRunApi = (data: {
  runId: string;
  testId: string;
  prefix: string;
  definition?: any;
  settings?: any;
}) =>
  INSTANCE.post('/v1/admin/test/runs', data, {
    headers: { Authorization: getToken() },
  }).then((res) => res.data);

export const updateTestRunApi = (id: string, data: any) =>
  INSTANCE.put(`/v1/admin/test/runs/${id}`, data, {
    headers: { Authorization: getToken() },
  }).then((res) => res.data);

export const appendTestRunLogsApi = (id: string, data: { logs?: any[]; errors?: any[] }) =>
  INSTANCE.put(`/v1/admin/test/runs/${id}/logs`, data, {
    headers: { Authorization: getToken() },
  }).then((res) => res.data);

export const cleanupTestProgramApi = (programId: string, runId?: string) =>
  INSTANCE.post(
    `/v1/admin/test/cleanup/${programId}`,
    { runId },
    { headers: { Authorization: getToken() } }
  ).then((res) => res.data);

export const getTestProgramsApi = () =>
  INSTANCE.get('/v1/admin/test/programs', {
    headers: { Authorization: getToken() },
  }).then((res) => res.data);

export const getTestSpeedApi = () =>
  INSTANCE.get('/v1/admin/test/speed', {
    headers: { Authorization: getToken() },
  }).then((res) => res.data);

export const setTestSpeedApi = (speedMultiplier: number) =>
  INSTANCE.put(
    '/v1/admin/test/speed',
    { speedMultiplier },
    { headers: { Authorization: getToken() } }
  ).then((res) => res.data);
